/**
 * Medbook
 * Medbook api
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface TodoAddItemsToTodoBodyItemsInner { 
    /**
     * 
     */
    id: number;
    /**
     * 
     */
    module: TodoAddItemsToTodoBodyItemsInner.ModuleEnum;
    /**
     * 
     */
    item?: object;
}
export namespace TodoAddItemsToTodoBodyItemsInner {
    export type ModuleEnum = 'assessments' | 'internships' | 'logbook' | 'portfolio' | 'reflections' | 'training' | 'opleiding' | 'leeragenda' | 'learning-agenda' | 'certificate' | 'cases' | 'any';
    export const ModuleEnum = {
        Assessments: 'assessments' as ModuleEnum,
        Internships: 'internships' as ModuleEnum,
        Logbook: 'logbook' as ModuleEnum,
        Portfolio: 'portfolio' as ModuleEnum,
        Reflections: 'reflections' as ModuleEnum,
        Training: 'training' as ModuleEnum,
        Opleiding: 'opleiding' as ModuleEnum,
        Leeragenda: 'leeragenda' as ModuleEnum,
        LearningAgenda: 'learning-agenda' as ModuleEnum,
        Certificate: 'certificate' as ModuleEnum,
        Cases: 'cases' as ModuleEnum,
        Any: 'any' as ModuleEnum
    };
}


